import React from 'react';
import './SuccessChange.scss';
import { Icon } from '../../../../components/common/IconLibrary';

interface SuccessChangeProps {
  success: boolean; // Indica si el cambio fue exitoso o fallido
}

const SuccessChange: React.FC<SuccessChangeProps> = ({ success }) => {
  return (
    <div className="success-change-container">
      {/* Ícono centrado, cambia según el estado de éxito o error */}
      <div className="centered-icon">
        <Icon iconName={success ? "check" : "cancel"} iconColor="orange" size={64} />
      </div>

      {/* Título dinámico según el estado de éxito o error */}
      <div className={success ? "success-change-title" : "error-title"}>
        {success ? "¡Contraseña restablecida!" : "Ups, inténtalo más tarde"}
      </div>

      {/* Mensaje dinámico según el estado de éxito o error */}
      <div className={success ? "success-change-message" : "error-message"}>
        {success
          ? "Tu contraseña ha sido restablecida con éxito."
          : "No hemos podido restablecer tu contraseña. Por favor, inténtalo más tarde."}
      </div>
    </div>
  );
};

export default SuccessChange;
